// packages/utils/src/client/pageRelease.ts
//
// Whether THIS PAGE is from another release than the server it talks to: known from the first
// server-action call the server did not know. Every deploy gives every action a new id (why:
// `@tourtask/utils/server/http/actionFromOtherRelease`), so after a deploy every page left open
// calls ids the new server never had, and only a reload brings the new ones.
//
// One flag for the whole page — a module, so every `requestAction` of the page shares it — which a
// reload clears. `runActionRequest` sets it and then stops calling the server (a background poll gets
// the failure at once, a click the *Page out of date* dialog); `useOlderReleaseRecovery`
// (`@tourtask/ui`) subscribes and gets the page onto the live release.

let fromOtherRelease = false;
const listeners = new Set<() => void>();

/** The server did not know an action this page called: the page is from another release. */
export function markPageFromOtherRelease(): void {
  if (fromOtherRelease) return;
  fromOtherRelease = true;
  for (const listener of listeners) listener();
}

export function isPageFromOtherRelease(): boolean {
  return fromOtherRelease;
}

/** `useSyncExternalStore`'s subscribe: `listener` runs once, when the page is marked. */
export function subscribePageRelease(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
